import React, { useState, useEffect, Fragment } from "react";
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { CreditCardOutlined, MoreHoriz } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid } from "@mui/x-data-grid";
import Moment from "moment";
import {
  Grid,
  Box,
  DialogContent,
  DialogActions,
  Dialog,
  Alert,
} from "@mui/material";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewsCardCollectionAdmin(props) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);

  const [state] = useState({
    columns: [
      {
        headerName: "Tarjeta",
        field: "responseTransaction",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <b style={{ fontSize: 12 }}>
              {params.row?.responseTransaction.subscription.instrument[3].value}
            </b>
          );
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Último dígito",
        field: "id",
        width: 240,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        align: "center",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <>
              <CreditCardOutlined sx={{ mr: 1 }} />
              <MoreHoriz sx={{ mx: 0.5 }} />
              <MoreHoriz sx={{ mx: 0.5 }} />
              <MoreHoriz sx={{ mx: 0.5 }} />
              {params.row?.responseTransaction.subscription.instrument[5].value}
            </>
          );
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Vencimiento",
        field: "reference",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const expiryRaw =
            params.row?.responseTransaction.subscription?.instrument[6]?.value;
          const expiryDate = new Date(expiryRaw.trim());
          const today = new Date();
          const isExpired = expiryDate < today;
          return (
            <b style={{ fontSize: 12, color: isExpired ? "red" : "" }}>
              {Moment(
                params.row?.responseTransaction.subscription.instrument[6].value
              ).format("DD-MM-YYYY")}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            wordWrap: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "----",
        field: "reference0",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const expiryRaw =
            params.row?.responseTransaction.subscription?.instrument[6]?.value;
          const expiryDate = new Date(expiryRaw.trim());
          const today = new Date();
          const isExpired = expiryDate < today;
          return (
            <b style={{ fontSize: 10, color: isExpired ? "red" : "green" }}>
              {isExpired
                ? "CADUCADA"
                : params.row?.select === 1
                ? "SELECCIONADA"
                : ""}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            wordWrap: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable(0);
  }, []);

  const RefreshTable = (n, data = null) => {
    if (n !== 0) {
      props.callBackRefresh();
      setRows(data);
    } else {
      let transformedRows = [];

      if (
        Array.isArray(props.id.row.cardCollection) &&
        props.id.row.cardCollection.length > 0
      ) {
        transformedRows = props.id.row.cardCollection.map((data) => ({
          ...data,
          responseTransaction: JSON.parse(data.responseTransaction),
        }));

        setRows(transformedRows);
      }
    }

    setLoader(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        // style={{ zIndex: 100 }}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.cardTitleBlack}>
                <CreditCardOutlined className={classes.iconFilter} /> Listado de
                tarjetas del cliente
              </div>
              <Card>
                <CardBody>
                  <Alert severity="info">
                    Listado de tarjeta para cobros recurrentes.
                  </Alert>
                  {loader ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <center>
                          <img
                            alt="loaderGif"
                            src={loaderGif}
                            style={{ width: 60, margin: "20% 0" }}
                          />
                        </center>
                      </Grid>
                    </Grid>
                  ) : (
                    <Fragment>
                      <Grid container>
                        {rows.length > 0 ? (
                          <Grid item xs={12} sm={12}>
                            <Box
                              sx={{
                                "& .super-app.celAll": {
                                  fontSize: 12,
                                  //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                                },
                                "& .super-app.celActions": {
                                  backgroundColor: "rgb(242, 242, 242)",
                                },
                                "& .super-app-theme--header": {
                                  backgroundColor: "rgb(242, 242, 242)",
                                },
                                "& .super-app.wordWrap": {
                                  fontSize: 10,
                                  textAlign: "center",
                                },
                                marginTop: 2,
                              }}
                            >
                              <DataGrid
                                rows={rows}
                                columns={state.columns}
                                loading={loader}
                                initialState={{
                                  pagination: {
                                    paginationModel: { page: 0, pageSize: 10 },
                                  },
                                }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                disableRowSelectionOnClick={true}
                                checkboxSelection={false}
                                //rowHeight={40}
                                autoHeights
                              />
                            </Box>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={12}>
                            <center>
                              <img
                                alt="loaderGif"
                                src={noDataImg}
                                style={{ width: 200, marginTop: 50 }}
                              />
                              <br></br>
                              <b
                                style={{ fontSize: 16, margin: "5px 0 70px 0" }}
                              >
                                No hay registros para mostrar
                              </b>
                            </center>
                          </Grid>
                        )}
                      </Grid>
                    </Fragment>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
